<template>
  <Teleport to="body">
    <div
      class="fixed left-0 top-0 z-drawer h-full w-full bg-black/60 transition-opacity"
      :class="
        isOpen
          ? 'pointer-events-auto visible opacity-100'
          : 'pointer-events-none invisible opacity-0'
      "
      @click.stop="handleClickMask"
    />
    <div
      class="fixed z-drawer bg-white transition-transform duration-300"
      :class="[positionClass, sizeClass, transformClass]"
      @click.stop
    >
      <slot />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
  interface IProps {
    isOpen: boolean;
    maskClosable?: boolean;
    direction?: 'right' | 'bottom';
  }

  const props = withDefaults(defineProps<IProps>(), {
    maskClosable: true,
    direction: 'bottom',
  });

  const emits = defineEmits<{
    (e: 'close'): void;
  }>();

  const mainStore = useMainStore();

  const handleClickMask = (): void => {
    if (props.maskClosable) {
      emits('close');
    }
  };

  const positionClass = computed((): string => {
    return props.direction === 'right' ? 'right-0 top-0' : 'bottom-0 left-0';
  });

  const sizeClass = computed((): string => {
    return props.direction === 'right'
      ? 'h-full container-scrollbar overflow-y-auto'
      : 'max-h-[calc(100%-4rem)] w-full rounded-t-lg overflow-y-auto';
  });

  const transformClass = computed((): string => {
    if (props.direction === 'right') {
      return props.isOpen ? 'translate-x-0' : 'translate-x-full';
    } else {
      return props.isOpen ? 'translate-y-0' : 'translate-y-full';
    }
  });

  watch(
    () => props.isOpen,
    (value: boolean) => {
      mainStore.isBodyFixed = value;
    }
  );

  onBeforeUnmount(() => {
    mainStore.isBodyFixed = false;
  });
</script>
